"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What should I do if my pet has an emergency after hours?",
  answer: "If your pet experiences an emergency outside of our regular business hours, please contact our 24/7 emergency partner clinic immediately. We maintain a close relationship with local trauma centers to ensure your pet receives continuous care."
}, {
  question: "How do I know if my pet needs urgent care?",
  answer: "Signs that require immediate attention include difficulty breathing, persistent vomiting or diarrhea, ingestion of toxic substances, sudden collapse, or severe bleeding. When in doubt, call us immediately for guidance."
}, {
  question: "Do I need an appointment for urgent care services?",
  answer: "While we prioritize life-threatening emergencies, we recommend calling ahead so our medical team can prepare for your arrival and provide immediate triage instructions over the phone."
}, {
  question: "What information should I have ready when I call?",
  answer: "Please be prepared to describe your pet's symptoms, any known medical conditions, current medications, and the approximate time the issue began. This helps our triage team assess the level of urgency."
}, {
  question: "Can I perform first aid on my pet at home?",
  answer: "Basic first aid like applying pressure to a wound can be helpful, but always consult with a professional first. Never administer human medications to your pet as many are highly toxic to animals."
}, {
  question: "What are your triage protocols for emergency cases?",
  answer: "Upon arrival, a technician will immediately assess your pet's vital signs. Patients are seen based on the severity of their condition rather than arrival time to ensure the most critical cases receive life-saving care first."
}, {
  question: "How much does an emergency visit typically cost?",
  answer: "Emergency fees cover the immediate stabilization and intensive assessment of your pet. We will provide a detailed estimate for any diagnostic tests or treatments after the initial triage and examination."
}, {
  question: "Do you offer payment plans for emergency procedures?",
  answer: "We understand that emergencies are unexpected. We accept major credit cards and partner with third-party financing options like CareCredit to help manage the costs of life-saving veterinary care."
}];
export default function UrgentCareFaq() {
  return <section data-section-id="256918" id="urgent-care-faq" className="dark bg-background py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <h2 className="font-default text-3xl font-semibold tracking-tight text-foreground md:text-5xl">
            Emergency & Urgent Care
          </h2>
        </div>

        <div className="rounded-3xl border border-border bg-muted/30 p-4 shadow-lg md:p-8 backdrop-blur-sm">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/50">
                <AccordionTrigger className="text-left font-default text-lg font-medium text-foreground hover:text-primary hover:no-underline transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-default text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}